import { Search, X } from "lucide-react";

export function SearchInput({ value, onChange, placeholder = "Search..." }) {
  return (
    <div className="flex-1 relative">
      <input
        type="text"
        placeholder={placeholder}
        className="w-full pl-10 pr-9 py-2.5 bg-white rounded-lg text-sm border  border-gray-200  focus:border-transparent focus:ring-2 focus:ring-primary"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Search size={18} className="absolute left-3 top-3 text-gray-400" />
      {value && (
        <button
          onClick={() => onChange("")}
          className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600 "
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
